import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,

  loadingList: false,
  dataList: null,
  errorsList: null,

  loadingMember: false,
  dataMember: null,
  errorsMember: null,

  loadingDevice: false,
  dataDevice: null,
  errorsDevice: null,

  loadingNotification: false,
  dataNotification: null,
  errorsNotification: null,
}

export const getters = {
  getLastMeasure(state) {
    return state.data
  },
  getListDelivery(state) {
    return state.dataList
  },
  getMemberChart(state) {
    return state.dataMember
  },
  getDeviceChart(state) {
    return state.dataDevice
  },

  getNotificationChart(state) {
    return state.dataNotification
  },
}

export const mutations = {
  SET_MEMBER_CHART_REQUESTED(state) {
    state.loadingMember = true
  },
  SET_MEMBER_CHART_RECEIVED(state, newData) {
    state.loadingMember = false
    state.dataMember = newData
    state.errorsMember = null
  },
  SET_MEMBER_CHART_RECEIVED_FAILED(state, error) {
    state.loadingMember = false
    state.errorsMember = error
  },
  RESET_MEMBER_CHART(state) {
    state.loadingMember = false
    state.dataMember = null
    state.errorsMember = null
  },

  SET_DEVICE_CHART_REQUESTED(state) {
    state.loadingDevice = true
  },
  SET_DEVICE_CHART_RECEIVED(state, newData) {
    state.loadingDevice = false
    state.dataDevice = newData
    state.errorsDevice = null
  },
  SET_DEVICE_CHART_RECEIVED_FAILED(state, error) {
    state.loadingDevice = false
    state.errorsDevice = error
  },
  RESET_DEVICE_CHART(state) {
    state.loadingDevice = false
    state.dataDevice = null
    state.errorsDevice = null
  },

  SET_NOTIFICATION_CHART_REQUESTED(state) {
    state.loadingNotification = true
  },
  SET_NOTIFICATION_CHART_RECEIVED(state, newData) {
    state.loadingNotification = false
    state.dataNotification = newData
    state.errorsNotification = null
  },
  SET_NOTIFICATION_CHART_RECEIVED_FAILED(state, error) {
    state.loadingNotification = false
    state.errorsNotification = error
  },

  SET_LAST_MEASURE_REQUESTED(state) {
    state.loading = true
  },
  SET_LAST_MEASURE_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_LAST_MEASURE_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_LAST_MEASURE(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },

  SET_LIST_DELIVERY_REQUESTED(state) {
    state.loadingList = true
  },
  SET_LIST_DELIVERY_RECEIVED(state, newData) {
    state.loadingList = false
    state.dataList = newData
    state.errorsList = null
  },
  SET_LIST_DELIVERY_RECEIVED_FAILED(state, error) {
    state.loadingList = false
    state.errorsList = error
  },
}

export const actions = {
  async fetchingMemberChart({ commit }, params) {
    commit('SET_MEMBER_CHART_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/member/charts/count/',
        payload: { ...params },
      })
      commit('SET_MEMBER_CHART_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_MEMBER_CHART_RECEIVED_FAILED', error)
    }
  },
  async fetchingDeviceChart({ commit }, params) {
    commit('SET_DEVICE_CHART_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/device/charts/usage/',
        payload: { ...params },
      })
      commit('SET_DEVICE_CHART_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_DEVICE_CHART_RECEIVED_FAILED', error)
    }
  },
  async fetchingNotificationChart({ commit }, params) {
    commit('SET_NOTIFICATION_CHART_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/notification/number/charts/count/',
        payload: { ...params },
      })
      commit('SET_NOTIFICATION_CHART_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_NOTIFICATION_CHART_RECEIVED_FAILED', error)
    }
  },
  async fetchingLastMeasure({ commit }, params) {
    commit('SET_LAST_MEASURE_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/member/last_measure/',
        payload: { ...params },
      })
      commit('SET_LAST_MEASURE_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_LAST_MEASURE_RECEIVED_FAILED', error)
    }
  },
  async fetchingListDelivery({ commit }, params) {
    commit('SET_LIST_DELIVERY_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/notification/list/',
        payload: {
          ...params,
        },
      })
      commit('SET_LIST_DELIVERY_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_LIST_DELIVERY_RECEIVED_FAILED', error)
    }
  },
  resetLastMeasure({ commit }) {
    commit('RESET_LAST_MEASURE')
  },
  resetMemberChart({ commit }) {
    commit('RESET_MEMBER_CHART')
  },
  resetDeviceChart({ commit }) {
    commit('RESET_DEVICE_CHART')
  },
}
